'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = {
  ctaDisclaimer: react.css`
    ${styleMixins_reset.boxSizing};
    margin: var(--zds-space-8) 0;
  `
};
const DisclaimerText = ({ color = "primary", termsLink = "https://zapier.com/tos", textType = "Body1", privacyLink = "https://zapier.com/privacy" }) => {
  const textColor = color === "primary" ? "GrayWarm9" : "PrimeWhite";
  return react.jsx(
    "div",
    { css: Styles.ctaDisclaimer, "data-zds": true },
    react.jsx(
      components_display_Text_Text.Text,
      { tag: "p", type: textType, color: textColor },
      "By signing up, you agree to Zapier’s",
      " ",
      react.jsx(components_navigation_Link_Link.Link, { href: termsLink, color }, "Terms of Service"),
      " ",
      "and",
      " ",
      react.jsx(components_navigation_Link_Link.Link, { href: privacyLink, color }, "Privacy Policy"),
      "."
    )
  );
};

exports.DisclaimerText = DisclaimerText;
//# sourceMappingURL=DisclaimerText.cjs.js.map
